import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener('promote:open-learner-report', this._openEditor.bind(this));
    document.addEventListener('promote:close-learner-report', this.closeEditor.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:open-learner-report', this._openEditor.bind(this));
    document.removeEventListener('promote:close-learner-report', this.closeEditor.bind(this));
  }

  closeEditor() {
    this.panelEditorController.closePanel();
  }

  get panelEditorController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'panel-editor');
  }

  _openEditor() {
    this.panelEditorController.openPanel();
  }
}
